import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Card, CardContent, Button, IconButton, MenuItem, Select, Typography } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import { useMediaQuery, useTheme } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';
import {
    validatePin4Length,
} from '../../utils/regex/Regex';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import OTPInput from "otp-input-react";
import { useDispatch, useSelector } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { showOtpModalChangePin } from '../../redux/create-actions/OtpAction';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import Color from '../../layouts/Color';
import FontSize from '../../layouts/FontSize';
import { graphGenOtp } from '../../services/OneTimePassword';
import { graphGetAllContractByCustomer } from '../../services/Contract';

const useStyles = makeStyles(function (theme) {
    return {
        gridContainer: {
            [theme.breakpoints.up("sm")]: {
                paddingLeft: '100px',
                paddingRight: '100px'
            },
            [theme.breakpoints.up("md")]: {
                paddingLeft: '150px',
                paddingRight: '150px'
            },
            [theme.breakpoints.up("lg")]: {
                paddingLeft: '200px',
                paddingRight: '200px'
            },
            [theme.breakpoints.only("xl")]: {
                paddingLeft: '20vw',
                paddingRight: '20vw'
            },

        },
    };
});

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const container = { mt: 1, textAlign: 'left' };
const buttonSubmit = {
    color: Color.Button,
    backgroundColor: Color.Dangerous,
    '&:hover': { background: Color.Button, color: Color.Dangerous }
};

export default function PinChangeForm(props) {

    const [contract, setContract] = useState(null);
    const [contractID, setContractID] = useState(null)
    const [listContract, setListContract] = useState([]);
    const [showOldPin, setOldShowPin] = useState(false);
    const [showNewPin, setNewShowPin] = useState(false);
    const [showNewPinConfirm, setNewShowPinConfirm] = useState(false);
    const theme = useTheme();
    const classes = useStyles();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const [pinOld, setPinOld] = useState("");
    const [pinNew, setPinNew] = useState("");
    const [pinNewConfirm, setPinNewConfirm] = useState("");
    const [pinLength, setPinLength] = useState(4);

    const data = useSelector(state => state.otp.data);
    const dispatch = useDispatch();

    const handleClickShowOldPin = () => setOldShowPin(!showOldPin);
    const handleMouseDownOldPin = () => setOldShowPin(!showOldPin);

    const handleClickShowNewPin = () => setNewShowPin(!showNewPin);
    const handleMouseDownNewPin = () => setNewShowPin(!showNewPin);

    const handleClickShowNewPinConfirm = () => setNewShowPinConfirm(!showNewPinConfirm);
    const handleMouseDownNewPinConfirm = () => setNewShowPinConfirm(!showNewPinConfirm);

    useEffect(() => {
        if (contract !== null) {
            setPinLength(contract.product.pinLength);
            if (data.newPin === '' && data.oldPin === '') {
                setPinOld("");
                setPinNew("");
                setPinNewConfirm("");
            }
        }
    }, [contract, data.newPin, data.oldPin]);

    useEffect(() => {
        if (contractID !== null && listContract.length !== 0) {
            setContract(listContract.filter((e) => e.id === contractID)[0]);
        }
    }, [contractID, listContract])

    useEffect(() => {
        dispatch(openLoadingApi());
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setContractID(result.items[0].id);
            setListContract(result.items);
            dispatch(closeLoadingApi());
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    const handleChangeOldPin = (event) => {
        var value = pinOld ? event : (pinOld + event);
        setPinOld(value);
    }

    const handleChangeNewPin = (event) => {
        var value = pinNew ? event : (pinNew + event);
        setPinNew(value);
    };

    const handleChangePinNewConfirm = (event) => {
        var value = pinNewConfirm ? event : (pinNewConfirm + event);
        setPinNewConfirm(value);
    };

    const handleClick = () => {
        let validateOld = validatePin4Length(pinOld);
        let validateNew = validatePin4Length(pinNew);
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        if (pinNew === pinNewConfirm) {
            if (!validateOld) {
                alert = { ...alert, message: "Please select correct OLD PIN format!" };
                dispatch(showAlert(alert));
            } if (!validateNew) {
                alert = { ...alert, message: "Please select correct NEW PIN format!" };
                dispatch(showAlert(alert));
            } if (!validateOld && !validateNew) {
                alert = { ...alert, message: "Please select correct NEW & OLD PIN format!" };
                dispatch(showAlert(alert));
            } else {
                dispatch(openLoadingApi())

                let sendOtp = graphGenOtp();
                sendOtp
                    .then(result => {
                        dispatch(closeLoadingApi())
                        if (result === 'SMS') {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number" };
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalChangePin(contractID, pinNew, pinOld, "CHANGE_PIN"));
                        } else {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App" };
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalChangePin(contractID, pinNew, pinOld, "CHANGE_PIN"));
                        }
                    }).catch(function (error) {
                        const err = JSON.parse(JSON.stringify(error))
                        alert = { ...alert, message: err.response.errors[0].message };
                        dispatch(closeLoadingApi());
                        dispatch(showAlert(alert));
                    })
            }
        }
        else {
            alert = { ...alert, message: "New PIN and Confirm PIN are not the same!" }
            dispatch(showAlert(alert));
        }
    }

    const renderReloadPinOld = (OTPLength) => {
        return (
            <Grid item md={9} xs={12} sx={{ display: 'flex', alignItem: 'center', justifyContent: `${matchDownSM ? 'center' : 'start'}` }}>
                <OTPInput
                    value={pinOld}
                    onChange={handleChangeOldPin}
                    autoFocus
                    OTPLength={OTPLength}
                    inputStyles={{
                        marginRight: `${matchDownSM ? '5px' : '20px'}`,
                        outline: 'none',
                        border: `1px solid ${theme.palette.background.default}`,
                        borderBottom: '1px solid #999',
                        width: `${matchDownSM ? '28px' : '32px'}`,
                        height: `${matchDownSM ? '28px' : '32px'}`,

                    }}
                    secure={showOldPin ? false : true}
                    otpType="number"
                    disabled={false}
                    style={{
                        marginLeft: ` ${matchDownSM ? '5px' : '20px'}`,

                    }}
                />

                <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowOldPin}
                    onMouseDown={handleMouseDownOldPin}
                    size={matchDownSM ? "small" : "medium"}
                >
                    {showOldPin ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        )
    }

    const renderReloadPinNew = (OTPLength) => {
        return (
            <Grid item md={9} xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: `${matchDownSM ? 'center' : 'start'}` }}>

                <OTPInput
                    value={pinNew}
                    onChange={handleChangeNewPin}
                    autoFocus
                    OTPLength={OTPLength}
                    inputStyles={{
                        marginRight: `${matchDownSM ? '5px' : '20px'}`,
                        outline: 'none',
                        border: '1px solid #fff',
                        borderBottom: '1px solid #999',
                        width: `${matchDownSM ? '28px' : '32px'}`,
                        height: `${matchDownSM ? '28px' : '32px'}`,
                    }}
                    secure={showNewPin ? false : true}
                    otpType="number"
                    disabled={false}
                    style={{
                        marginLeft: ` ${matchDownSM ? '5px' : '20px'}`,
                    }}
                />

                <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowNewPin}
                    onMouseDown={handleMouseDownNewPin}
                    size={matchDownSM ? "small" : "medium"}
                >
                    {showNewPin ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        )
    }

    const renderReloadPinNewConfirm = (OTPLength) => {
        return (
            <Grid item md={9} xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: `${matchDownSM ? 'center' : 'start'}` }}>
                <OTPInput
                    value={pinNewConfirm}
                    onChange={handleChangePinNewConfirm}
                    autoFocus
                    OTPLength={OTPLength}
                    inputStyles={{
                        marginRight: `${matchDownSM ? '5px' : '20px'}`,
                        outline: 'none',
                        border: '1px solid #fff',
                        borderBottom: '1px solid #999',
                        width: `${matchDownSM ? '28px' : '32px'}`,
                        height: `${matchDownSM ? '28px' : '32px'}`,
                        display: 'flex'
                    }}
                    secure={showNewPinConfirm ? false : true}
                    otpType="number"
                    disabled={false}
                    style={{
                        marginLeft: ` ${matchDownSM ? '5px' : '20px'}`,
                    }}
                />
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowNewPinConfirm}
                    onMouseDown={handleMouseDownNewPinConfirm}
                    size={matchDownSM ? "small" : "medium"}
                >
                    {showNewPinConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        )
    }

    const handleChangeContract = (event) => {
        setContractID(event.target.value);
    };

    return (contract !== null && contractID !== null) ? (
        <Paper variant="outlined" sx={paperStyle}>
            <Grid container alignContent="center" justifyContent="space-between">
                <Grid item>
                    <Button id="change-pin" endIcon={<SettingsIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
                        Change PIN
                    </Button>
                </Grid>
            </Grid>
            <Card>
                <CardContent>
                    <Grid container spacing={gridSpacing} className={classes.gridContainer} alignItems="center" justifyContent="center" sx={container}>
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item md={3} xs={12}>
                                <Typography variant="h4"> Card Number: </Typography>
                            </Grid>
                        )}
                        <Grid item md={9} xs={12}>
                            <Select
                                fullWidth
                                labelId="cardnumberl-filter"
                                id="demo-simple-select-helper"
                                value={contractID}
                                onChange={handleChangeContract}
                                size="medium"
                                sx={{
                                    '& .MuiInputBase-input': {
                                        bgcolor: theme.palette.background.default
                                    },
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                {
                                    listContract?.map((contract) => {
                                        return (
                                            <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                                                {(contract.contractNumber).slice(0, 4)}&emsp;{(contract.contractNumber).slice(4, 8).replace("__", "**")}&emsp;{(contract.contractNumber).slice(8, 12).replace("____", "****")}&emsp;{(contract.contractNumber).slice(12, 16)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Typography variant="h4"> Old PIN: </Typography>
                        </Grid>
                        {renderReloadPinOld(pinLength)}
                        <Grid item md={3} xs={12}>
                            <Typography variant="h4"> New PIN: </Typography>
                        </Grid>
                        {renderReloadPinNew(pinLength)}
                        <Grid item md={3} xs={12}>
                            <Typography variant="h4"> Confirm PIN: </Typography>
                        </Grid>
                        {renderReloadPinNewConfirm(pinLength)}
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item sm={0} xs={0} md={3} xl={3}></Grid>
                        )}
                        <Grid item sm={12} xs={12} md={9} xl={9} sx={{ textAlign: `${matchDownSM ? 'center' : 'left'}`, }}>
                            <Button
                                sx={buttonSubmit}
                                variant="contained"
                                onClick={handleClick}
                                endIcon={<KeyboardArrowUpIcon></KeyboardArrowUpIcon>}
                            >
                                Submit</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Paper>
    ) : (
        <Paper variant="outlined" sx={paperStyle}>

        </Paper>
    );
}